import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { IDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { regelingProp } from "../utils/contactFormulierProps";

export const regelingAlgemeenDetails: IDependsOn[] = [
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.BeschermdWonen,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.Buitenland,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.CBHC,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.Gemoedsbezwaarden,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.MedicijnenMeeOpReis,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.Onbekend,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.OnverzekerbareVreemdelingen,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.Onverzekerden,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.SOV,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.BetalingsachterstandZorgpremie,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsNotGiven,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

const regelingWmoDetails: IDependsOn[] = [
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.Wlz,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

const regelingWlzDetails: IDependsOn[] = [
  {
    property: regelingProp,
    if: DependsOnIfEnum.IsEqualToValue,
    value: RegelingOptions.WmoAT,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

export const dependsOnRegelingWmo: IDependsOn[] = [...regelingAlgemeenDetails, ...regelingWmoDetails];

export const dependsOnRegelingWlz: IDependsOn[] = [...regelingAlgemeenDetails, ...regelingWlzDetails];
